import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award } from "lucide-react";
import { api } from "../lib/api";

const abs = (u) => (u || "").startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;

/** Active cashback campaigns — visible to every user. */
export default function CampaignsStrip() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/loyalty/campaigns").then((r) => setItems(r.data.active || [])).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <div className="space-y-2 min-w-0 max-w-full" data-testid="campaigns-strip">
      <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-[#10B981] flex items-center gap-1.5">
        <Award size={11} /> Active campaigns
      </div>
      <div className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1">
        {items.map((c) => (
          <Link key={c.id} to="/app/loyalty" data-testid={`campaign-card-${c.id}`}
                className="flex-shrink-0 w-64 rounded-2xl overflow-hidden border border-[#10B981]/40 bg-[#13131E] hover:border-[#10B981] transition-colors">
            {c.image_url && <img src={abs(c.image_url)} alt={c.name} className="w-full h-24 object-cover" />}
            <div className="p-3">
              <div className="text-sm font-bold truncate">{c.name}</div>
              <div className="text-[#10B981] font-black text-lg">+{c.cashback_pct}% cashback</div>
              <div className="text-[9px] text-[#9CA3D4]">Until {new Date(c.end_at).toLocaleDateString()}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
